import SvgIcon from '@mui/material/SvgIcon';

export const MicrosoftIcon = () => (
  <SvgIcon
    width="57"
    height="57"
    viewBox="0 0 57 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0H57V57H0V0Z" fill="#F3F3F3" />
    <path
      d="M2.20729 2.20729H27.3964V27.3964H2.20729V2.20729Z"
      fill="#F35325"
    />
    <path
      d="M29.6036 2.20729H54.7927V27.3964H29.6036V2.20729Z"
      fill="#81BC06"
    />
    <path
      d="M2.20729 29.6036H27.3964V54.7927H2.20729V29.6036Z"
      fill="#05A6F0"
    />
    <path
      d="M29.6036 29.6036H54.7927V54.7927H29.6036V29.6036Z"
      fill="#FFBA08"
    />
  </SvgIcon>
);
